function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_410",
  "data-name": "Group 410",
  transform: "translate(0.967 0.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_379",
  "data-name": "Path 379",
  d: "M835.413,369.076V341.05h22.527l6.23,5.963V375.95H835.413v-2.938",
  transform: "translate(-826.085 -337.95)",
  fill: "none",
  stroke: "#2c3589",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_380",
  "data-name": "Path 380",
  d: "M867.31,347.053h-6.237v-6",
  transform: "translate(-829.072 -337.95)",
  fill: "none",
  stroke: "#2c3589",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_413",
  "data-name": "Group 413"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_137",
  "data-name": "Line 137",
  x2: 6,
  transform: "translate(-0.467 3)",
  fill: "none",
  stroke: "#2c3589",
  strokeLinecap: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_138",
  "data-name": "Line 138",
  x2: 6.203,
  transform: "translate(2.533) rotate(90)",
  fill: "none",
  stroke: "#2c3589",
  strokeLinecap: "round",
  strokeWidth: 1
})));

var SvgJoratoAddDocument = function SvgJoratoAddDocument(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39.705,
    height: 39,
    viewBox: "0 0 39.705 39",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJoratoAddDocument, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jorato-add-document.9c727801.svg";
export { ForwardRef as ReactComponent };